export default function () {
  return {
    funds: [],
    loading: false,
    loaded: false,
  }
}
